import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { environment } from 'environments';
import { TaxRate } from 'types';
import { EngagementType } from 'enums';

const TAXES_CONTROLLER_BASE_URL = `${environment.baseApiUrl}`;

export const fetchTaxes = createAsyncThunk('get:taxes', async () => {
  const { data } = await axios.get<TaxRate[]>(`${TAXES_CONTROLLER_BASE_URL}taxes`);

  // Only Individual tax rates
  return data.filter(({ engagementType }) => engagementType === EngagementType.Individuals);
});

export const updateTax = createAsyncThunk('patch:admin/taxes', async (tax: TaxRate) => {
  const { compensationType, legalEntity, rate, engagementType } = tax;

  await axios.patch(`${TAXES_CONTROLLER_BASE_URL}admin/taxes/${legalEntity}/${compensationType}/${engagementType}`, {
    taxRate: rate,
  });

  return tax;
});
